const getters = {
    // user
    signPop: state => state.user.signPop,
    calenPop: state => state.user.calenPop,
    calen: state => state.user.calen,
    token: state => state.user.token,
    userInfo: state => state.user.user,
    upimg: state => state.upimg,
    user: state => state.user,
}
export default getters
